<template>
  <div style="text-align: right;margin-bottom: 10px;">
    <p v-if="file_list.length > 0 && current_path.length > 0 ">
      path for download links: {{ current_path }}
    </p>
    <el-upload
      :on-change="handle_change"
      :on-remove="handle_remove"
      action="/upload_file_to_storage"
      :data="{current_path: current_path}"
      :headers="{ 'X-CSRF-TOKEN': csfr}"
      multiple
      :limit="50"
      :file-list="file_list"
    >
      <el-button
        size="small"
        type="primary"
      >
        Click to upload images
      </el-button>
    </el-upload>
  </div>
</template>

<script>

import Vue from 'vue';

export default {
  name: 'FileUpload',
  props: {
    current_path: {
      type: String,
      required: true
    },
    file_list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      csfr: Vue.http.headers.common['X-CSRF-Token'],
    };
  },
  mounted() {
    this.set_default_input();
  },
  methods: {
    handle_change(file, fileList) {
      this.$emit('update:file_list', fileList);
      this.$emit('file-list', fileList);
      console.log(file,fileList);
    },
    handle_remove(file, fileList) {
      this.$emit('update:file_list', fileList);
      this.$emit('file-list', fileList);
      console.log('Removed:', file, fileList);
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-select__input, .el-input__inner, .el-textarea__inner')).forEach(
        function (e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    },
  },
};
</script>

<style scoped>

</style>
